import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useDispatch } from "react-redux";
import { postTeam, postTeamMilestone } from "../../../../../redux/team/action";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import { titlevalidation } from "../../../../Common/commonvalidation";

export default function TeamsMilestoneModel({ setMilestoneModel, projectid }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState("");
  const dispatch = useDispatch();
  const initialValues = {
    title: formData?.expert?.title || "",
  };

  const validationSchema = Yup.object().shape({
    title: titlevalidation,
  });

  const handleSubmit = (values) => {
    setLoading(true);

    const data = {
      ...values,
      type: 2,
      team_project_id: projectid,
    };
    dispatch(postTeamMilestone(data));
    setMilestoneModel((state) => !state);
    setLoading(true);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ setFieldValue, errors }) => (
        <>
          <a
            onClick={() => setMilestoneModel((state) => !state)}
            className="btn close-button"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </a>
          <Form>
            <ModalBody>
              <h4>Create Milestone</h4>

              <div className="form-group">
                <label className="label-s">Milestone Title</label>
                <Field
                  className="form-control input"
                  type="text"
                  name="title"
                  placeholder="Your title"
                />
                <ErrorMessage name="title" component="div" className="error" />
              </div>
            </ModalBody>
            <div className="modal-footer mt-3">
              <button className="btn " type="submit" disabled={loading}>
                {loading ? <LoginLoaderButton /> : "Save"}
              </button>
            </div>
          </Form>
        </>
      )}
    </Formik>
  );
}
